import React, { useState, useEffect, useRef } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useHistory } from "react-router-dom"
import { useTranslation } from "react-i18next"

import { clearDeliveryAddress } from "@redux"
import { Navbar } from "components"
import PoSummary from "./PoSummary"
import PoPaymentDetails from "./PoPaymentDetails"
import PoOrderItem from "./PoOrderItem"
import PoOrderCombo from "./PoOrderCombo"
import PoCustomerDetails from "./PoCustomerDetails"
import PoAddressDetails from "./PoAddressDetails"
import classes from "./index.module.scss"

const initialCustomerInfoState = {
  accountId: "",
  fullName: "",
  mobilePhone: ""
}

const initialCustomerAddressState = {
  _id: "",
  accountId: "",
  areaName: "",
  address: "",
  city: "",
  state: "",
  zipCode: "",
  country: "ایران",
  recipientName: "",
  recipientPhoneNumber: "",
  location: {
    type: "Point",
    coordinates: [53.6880, 32.4279]
  }
}


const initialPaymentDetailsState = {
  note: "",
  paymentNote: "",
  linkPayMethod: "",
  paymentAttachUrls: []
}

const initialFormErrorsState = {
  fullName: "",
  mobilePhone: "",
  areaName: "",
  address: "",
  city: "",
  state: "",
  zipCode: "",
  paymentNote: "",
  paymentAttachUrls: ""
}

const PlaceOrder = () => {
  const [t] = useTranslation()

  const dispatch = useDispatch()

  const history = useHistory()

  const order = useSelector(state => state.order)

  const [deliveryFees, setDeliveryFees] = useState(null)
  const [customerInfo, setCustomerInfo] = useState(initialCustomerInfoState)
  const [customerAddress, setCustomerAddress] = useState(initialCustomerAddressState)
  const [paymentDetails, setPaymentDetails] = useState(initialPaymentDetailsState)
  const [formErrors, setFormErrors] = useState(initialFormErrorsState)

  const unmount = useRef(false)

  const handleGoBack = () => {
    dispatch(
      clearDeliveryAddress()
    )

    history.push("/foods")
  }

  useEffect(() => {
    unmount.current = false

    return () => unmount.current = true
  }, [])


  const orderItems = order.items

  const orderCombos = order.combos

  return (
    <div className={classes["container"]}>
      <Navbar
        title={t("ثبت_سفارش")}
        variant="compact"
        onLeftIconPress={handleGoBack}
      />
      <div className={classes["wrapper"]}>
        <div className={classes["section"]}>
          <div className={classes["title"]}>
            {t("جزئیات_سفارش")}
          </div>

          <div className={classes["order-items"]}>
            {order.items.map(orderItem => (
              <PoOrderItem
                key={orderItem.orderItemId}
                orderItem={orderItem}
              />
            ))}

            {order.combos.map((orderCombo, orderComboIndex) =>
              <PoOrderCombo
                key={orderComboIndex}
                orderCombo={orderCombo}
              />
            )}
          </div>

          <PoSummary
            deliveryFees={deliveryFees}
            orderItems={orderItems}
            orderCombos={orderCombos}
          />
        </div>

        <div className={classes["center-container"]}>
          <PoCustomerDetails
            formErrors={formErrors}
            customerInfo={customerInfo}
            setCustomerInfo={setCustomerInfo}
            setCustomerAddress={setCustomerAddress}
            initialCustomerInfoState={initialCustomerInfoState}
            initialCustomerAddressState={initialCustomerAddressState}
          />

          <PoAddressDetails
            formErrors={formErrors}
            customerAddress={customerAddress}
            setCustomerAddress={setCustomerAddress}
            setDeliveryFees={setDeliveryFees}
          />
        </div>

        <div className={classes["section"]}>
          <div className={classes["title"]}>
            {t("جزئیات_سفارش_و_پرداخت")}
          </div>

          <PoPaymentDetails
            formErrors={formErrors}
            setFormErrors={setFormErrors}
            paymentDetails={paymentDetails}
            setPaymentDetails={setPaymentDetails}
            orderItems={orderItems}
            orderCombos={orderCombos}
            customerInfo={customerInfo}
            setCustomerInfo={setCustomerInfo}
            customerAddress={customerAddress}
            setCustomerAddress={setCustomerAddress}
            initialFormErrorsState={initialFormErrorsState}
          />
        </div>
      </div>
    </div>
  )
}

export default PlaceOrder